import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppText } from '../AppText';
import Colors from '../../constants/Colors';
import { BookingMode } from '../../types/Site';
import { bookingModeLabel } from './siteFormatting';

const styles = StyleSheet.create({
  badge: {
    alignSelf: 'flex-start',
    height: 22,
    paddingHorizontal: 8,
    justifyContent: 'center',
    marginTop: 8,
  },
  text: {
    fontSize: 13,
    fontWeight: '700',
  },
  reservation: {
    backgroundColor: Colors.bookingBadgeReservationBackground,
    borderWidth: 1,
    borderColor: Colors.bookingBadgeReservationBorder,
    borderRadius: 4,
  },
  reservationText: { color: Colors.bookingBadgeReservationText },
  preRegistration: {
    backgroundColor: Colors.bookingBadgePreRegistrationBackground,
    borderWidth: 1,
    borderColor: Colors.bookingBadgePreRegistrationBorder,
    borderRadius: 4,
  },
  preRegistrationText: { color: Colors.bookingBadgePreRegistrationText },
  walkIn: {
    backgroundColor: Colors.bookingBadgeWalkInBackground,
    borderRadius: 11,
  },
  walkInText: { color: Colors.bookingBadgeWalkInText },
});

type BadgeVariant = Exclude<BookingMode, 'unknown'>;

const VARIANT_STYLES: Record<BadgeVariant, { container: object; text: object }> = {
  reservation: { container: styles.reservation, text: styles.reservationText },
  preRegistration: { container: styles.preRegistration, text: styles.preRegistrationText },
  walkIn: { container: styles.walkIn, text: styles.walkInText },
};

export interface BookingModeBadgeProps {
  bookingMode: BookingMode;
}

// Design tokens (colors, shapes) must stay consistent with the sibling `pantry-list-2a` handoff's
// booking-method badges -- see docs/superpowers/specs/2026-08-03-site-details-view-styling-design.md.
export function BookingModeBadge({ bookingMode }: BookingModeBadgeProps) {
  if (bookingMode === 'unknown') return null;

  const variant = VARIANT_STYLES[bookingMode];

  return (
    <View style={[styles.badge, variant.container]} testID={`booking-mode-badge-${bookingMode}`}>
      <AppText style={[styles.text, variant.text]}>{bookingModeLabel(bookingMode)}</AppText>
    </View>
  );
}
